import {
  Avatar,
  Button,
  Form,
  Input,
  List,
} from 'antd';
import React, { useEffect, useState } from 'react';
import {
  related_comments_ticket_path,
  ticket_comments_path,
} from 'js-routes/generated/routes';
import useErrors from 'hooks/forms/useErrors';
import { string, shape, number } from 'prop-types';
import CommentList from './CommentList';
import useSubmitForm from './hooks/useSubmitForm';
import useUpdateComment from './hooks/useUpdateComment';

const { TextArea } = Input;

const TicketComments = ({
  ticketId = null,
  currentUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
}) => {
  const [form] = Form.useForm();
  const [comments, setComments] = useState([]);

  useEffect(() => {
    fetch(related_comments_ticket_path(ticketId))
      .then((response) => response.json())
      .then((data) => setComments(data.comments));
  }, [ticketId]);

  const {
    handleError,
    clearErrors,
  } = useErrors();

  const { handleUpdateComment } = useUpdateComment({ setComments });

  const {
    isFormSending,
    handleSubmitForm,
    submitButtonName,
  } = useSubmitForm({
    form,
    formUrl: ticket_comments_path(),
    clearErrors,
    handleError,
    setComments,
  });

  return (
    <>
      {comments.length > 0 && <CommentList comments={comments} onUpdate={handleUpdateComment} />}

      <List.Item>
        <div className="tickets-index-page__ticket-comments-form">
          <Avatar
            src={currentUserInfo.avatarUrl}
            size={40}
          />

          <div style={{ flex: 1 }}>
            <Form
              component={false}
              form={form}
              layout="vertical"
              onFinish={handleSubmitForm}
              /* eslint-disable camelcase */
              initialValues={{
                author_type: currentUserInfo.type,
                author_id: currentUserInfo.id,
                ticket_id: ticketId,
              }}
              /* eslint-enable camelcase */
              disabled={isFormSending}
            >
              <Form.Item name="ticket_id" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item name="author_type" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item name="author_id" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item
                name="content"
                rules={[{ required: true, message: 'Please enter your comment' }]}
                className="tickets-index-page__form-item"
              >
                <TextArea
                  rows={4}
                  placeholder="Add a comment..."
                />
              </Form.Item>

              <Button
                type="primary"
                loading={isFormSending}
                onClick={() => form.submit()}
                size="small"
              >
                {submitButtonName}
              </Button>
            </Form>
          </div>
        </div>
      </List.Item>

    </>
  );
};

TicketComments.propTypes = {
  ticketId: number,
  currentUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
};

export default TicketComments;
